<template>
    <b-container fluid="md">
        <b-row align-h="center" cols="1" cols-lg="2" class="mb-2">
            <reservoir-info-importer />
        </b-row>
        <b-row align-h="center" cols="1" cols-lg="2">
            <b-col>
                <quota-info />
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import QuotaInfo from "./components/QuotaInfo";
import ReservoirInfoImporter from "./components/ReservoirInfoImporter";

export default {
    name: "InputData",
    components: {
        QuotaInfo,
        ReservoirInfoImporter
    }
};
</script>
